module.exports = __webpack_public_path__ + "components/flag/static/square/ly-8646e4c412b1b5e5347fb228f7816b3d.svg";